@if (!(checklistService.tasksLoading$ | async)) {
  <table
    mat-table
    [dataSource]="tableItems"
    >
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        @if (
          item.in_group &&
          (checklistService.permission$ | async | permission: '_edit')
          ) {
          <button
            mat-icon-button
            (click)="openEditDialog(item.consentChecklistTask)">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (checklistService.permission$ | async | permission: '_delete') {
          <button
            mat-icon-button
            (click)="deleteTask(item.consentChecklistTask)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="indicator">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="indicator">
        <consent-checklist-indicator
        [indicatorState]="item.indicator_state"></consent-checklist-indicator>
      </td>
    </ng-container>
    <ng-container matColumnDef="task">
      <th mat-header-cell *matHeaderCellDef="">Task</th>
      <td mat-cell *matCellDef="let item">{{ item.task }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef="">Status</th>
      <td mat-cell *matCellDef="let item">{{ item.status }}</td>
    </ng-container>
    <ng-container matColumnDef="due_date">
      <th mat-header-cell *matHeaderCellDef="">Due Date</th>
      <td mat-cell *matCellDef="let item">{{ item.due_date }}</td>
    </ng-container>
    <ng-container matColumnDef="started_date">
      <th mat-header-cell *matHeaderCellDef="">Start Date</th>
      <td mat-cell *matCellDef="let item">{{ item.started_date }}</td>
    </ng-container>
    <ng-container matColumnDef="responsible_party">
      <th mat-header-cell *matHeaderCellDef="">Responsible Party</th>
      <td mat-cell *matCellDef="let item">
        @if (item.responsible_party.name) {
          <contact-link
          [subject]="item.responsible_party"></contact-link>
        }
        @if (!item.responsible_party.name) {
          <span>{{
            item.responsible_party
          }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>Notes</th>
      <td mat-cell *matCellDef="let item">{{ item.notes }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
}
@if (checklistService.tasksLoading$ | async) {
  <div class="row centered">
    <mat-spinner></mat-spinner>
  </div>
}
